export default "__VITE_ASSET__14Bnk0VI__"